const namespaced = true

const state = {
	isFirstLoad: true,
	showCalculator: false
}


const mutations = {
	SET_FIRST_LOAD(state, data) {
		state.isFirstLoad = data
	},
	SET_SHOW_CALCULATOR(state, data) {
		state.showCalculator = data
	},
}

const actions = {
	setFirstLoad({ commit }, data) {
		commit('SET_FIRST_LOAD', data)
	},
	setShowCalculator({ commit }, data) {
		commit("SET_SHOW_CALCULATOR", data)
	}
}

export default {
	namespaced,
	state,
	mutations,
	actions
}